import { RouteName } from "../RouteNames";

export const newsRoutes = {
  name: RouteName.NewsRoot,
  path: "news-releases",
  redirect: () => ({ name: RouteName.News }),
  children: [
    {
      name: RouteName.News,
      path: "",
      component: () => import("@follaw-fr/views/side_menu_views/NewsView.vue"),
    },
    {
      name: RouteName.NewsZoom,
      path: ":_id",
      component: () =>
        import("@follaw-fr/views/side_menu_views/NewsZoomView.vue"),
    },
  ],
};
